import $ from "jquery";
import "../wrapper/select2";

function initialize() {
  $('.practice-select-with-search:not(.select2-hidden-accessible)').select2({
    language: 'de',
    dropdownCssClass: 'practice-select-dropdown'
  });
}

$(document).ready(initialize);

export default initialize;
